import React from "react";
import Box from "../../components/aboupage-project-description/Box";
import Heading from "../../components/Heading/Heading";
import AboutCSS from "./CSS/About.module.css";
import GithubCalendar from "react-github-calendar";
export default function About() {
  return (
    <>
      <div className={AboutCSS.container} id="about">
        <div className={AboutCSS.aboutPage}>
          <Heading heading="About" after="Me" />

          <div className={AboutCSS.content}>
            <div className={AboutCSS.profileDes}>
              <h1 className={AboutCSS.title}>
                Hi, I'm <span>Bikram Dutta</span>
              </h1>
              <p className={AboutCSS.aboutMe}>
                An aspiring Full-Stack Web Developer with a strong interest in
                projects requiring conceptual and analytical thinking.
                Self-motivated and hardworking fresher seeking for an
                opportunity to work a challenging environment to prove my skills
                and utilize my knowledge & intelligence in the growth of the
                organization.
              </p>
              <a
                style={{ textDecoration: "none" }}
                href="/Bikram-Dutta-Resume.pdf"
                onClick={() =>
                  window.open(
                    "https://drive.google.com/file/d/15Iu7X9IQaN-NcicdcUwga2S0vjkx-tL3/view?usp=sharing"
                  )
                }
                download={true}
              >
                <button className={AboutCSS.cv}>Resume</button>
              </a>
            </div>
            <div className={AboutCSS.projectDes}>
              <Box count="3" title="Total Project" />
              <Box count="1" title="Group Project" />
              <Box count="2" title="Individual Project" />
            </div>
          </div>
        </div>
        <div className={AboutCSS.aboutPage}>
          <Heading heading="Github" after="Calender & Statistics" />
          <div className={AboutCSS.github}>
            <GithubCalendar
              username="bikramboss8055"
              year={new Date().getFullYear()}
              blockSize={15}
              blockMargin={5}
              fontSize={14}
            />
          </div>
          <div className={AboutCSS.github1}>
            <a
              href="https://github.com/bikramboss8055"
              rel="noreferrer"
              target="_blank"
            >
              <img
                alt="7oSkaaa's Github Stats"
                src="https://github-readme-stats.vercel.app/api?username=bikramboss8055&show_icons=true&count_private=true&theme=algolia"
                height="192px"
              />
            </a>
            <a
              href="https://github.com/bikramboss8055"
              rel="noreferrer"
              target="_blank"
            >
              <img
                alt="7oSkaaa's Github Stats"
                src="https://github-readme-streak-stats.herokuapp.com?user=bikramboss8055&theme=algolia&border_radius=5"
                height="192px"
              />
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
